(function(angular) {
    var app = angular.module('enervee');

    /**
     * Creates an attribute directive: "on-form-change"
     *
     * @param {expression} onFormChange - Expression to evaluate whenever one
     * of the fields within the form changes. Shortcut for setting `ng-change`
     * on every field.
     *
     * Requires the attribute to be set on either a `<form>` or an element with
     * the `ng-form` attribute set.
     *
     * Special variables `$form` and `$field` are available for use in the
     * `onFormChange` expression, referencing the field that changed and the
     * form this directive is set on.
     *
     * @example
     * <example name="onFormChange-directive" module="onFormChangeExample">
     *   <script>
     *     angular.module('onFormChangeExample', [])
     *       .controller('ExampleController', function() {
     *         var vm = this;
     *         vm.testModel = '';
     *         vm.anotherTestModel = '';
     *         vm.onInnerFieldChange = function(field, form) {
     *           console.log("The field \"" + field.$name + "\" in the form \"" + form.$name + "\" has changed!");
     *         }
     *       });
     *   </script>
     *
     *   <div ng-controller="ExampleController as vm">
     *     <form name="mainForm">
     *       <div ng-form="subForm" on-form-change="vm.onInnerFieldChange($field, $form)">
     *         <input ng-model="vm.testModel" name="testModel" placeholder="Type here...">
     *         <input ng-model="vm.anotherTestModel" name="anotherTestModel" placeholder="Also type here...">
     *       </div>
     *     </form>
     *   </div>
     * </example>
     */
    app.directive('onFormChange', [function() {
        return {
            restrict: 'A',
            require: 'form',
            link: function(scope, elem, attrs, formCtrl) {
                /**
                 * @param {NgModelController} field - receives a field's model
                 * controller in order to set the `$field` variable on
                 * expression evaluation.
                 */
                var viewChangeCallback = function(field) {
                    var locals = {$form: formCtrl, $field: field};
                    scope.$eval(attrs.onFormChange, locals);
                };

                /**
                 * @param {NgModelController} field - receives a field's model
                 * controller in order to set the `$field` variable on
                 * expression evaluation.
                 * @return {Function} - the callback function for the `field`
                 */
                var getFieldChangedCallback = function(field) {
                    return function onFormChangeListener() {
                        viewChangeCallback(field);
                    };
                };

                var addFieldChangeListener = function(field) {
                    field.$viewChangeListeners.push(getFieldChangedCallback(field));
                };

                for (var key in formCtrl) {
                    var field = formCtrl[key];
                    var isField = (field && field.$viewChangeListeners);
                    if (isField) {
                        addFieldChangeListener(field);
                    }
                }

                // Crazy input elements that attach themselves to the form using
                // the $addControl method should fire this event and pass the
                // ngModel controller they attach
                scope.$on('form:addControl', function(e, field) {
                    addFieldChangeListener(field);
                });
            },
        };
    }]);
})(angular);
